import { z } from 'zod';

const SPECIAL_CHARS_REGEX = /[^a-zA-Z0-9]/;
const LETTERS_REGEX = /[a-zA-Z]/;
const NUMBERS_REGEX = /\d/;

const PASSWORD_MIN_LENGTH = 12;
const PASSWORD_MAX_LENGTH = 60;

export const UpdatePasswordSchema = z
  .object({
    password: z
      .string()
      .min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters`)
      .max(PASSWORD_MAX_LENGTH, `Password cannot exceed ${PASSWORD_MAX_LENGTH} characters`)
      .refine((val) => !val.startsWith(' ') && !val.endsWith(' '), {
        message: 'Password cannot start or end with a space',
      })
      .refine((val) => LETTERS_REGEX.test(val), {
        message: 'Password must contain at least one letter',
      })
      .refine((val) => NUMBERS_REGEX.test(val), {
        message: 'Password must contain at least one number',
      })
      .refine((val) => SPECIAL_CHARS_REGEX.test(val), {
        message: 'Password must contain at least one special character',
      }),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });

export type UpdatePasswordFormValues = z.infer<typeof UpdatePasswordSchema>;
